<template>
    <!-- Home Message-->
</template>

<script>
    export default {
        name: "HomeMessage"
    }
</script>